// extracted by mini-css-extract-plugin
export default {"moduleItem":"role-detail_moduleItem__IZluU","menuItem":"role-detail_menuItem__lD8uH","windowItem":"role-detail_windowItem__0VAJt"};